import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Theme from "./Theme";
import Header from "./components/Header/index";
import Footer from "./components/Footer/index";
import Home from "./page/Home";
import Login from "./page/Login";
import CreateUser from "./page/CreateUser";
import Product from "./page/Product";
import ProductSingle from "./page/ProductSingle";
import CategoriaProducts from "./page/CategoriaProducts";
import Cart from "./page/Cart";
import ProductSearch from "./page/ProductSearch";
import Order from "./page/Order";
import ConfirmOrder from "./page/ConfirmOrder";

function App() {
    return (
        <Theme>
            <BrowserRouter>
                <Header />
                <Switch>
                    <Route component={Home} exact path="/" />
                    <Route component={Login} exact path="/login" />
                    <Route
                        component={ProductSearch}
                        exact
                        path="/product/search"
                    />
                    <Route
                        component={CreateUser}
                        exact
                        path="/create-account"
                    />
                    <Route component={Product} exact path="/product" />
                    <Route
                        component={ProductSingle}
                        exact
                        path="/product-detail/:id"
                    />
                    <Route
                        component={CategoriaProducts}
                        exact
                        path="/categoria/:id"
                    />
                    <Route component={ConfirmOrder}
                    exact
                    path="/confirmOrder"/>
                    <Route component={Cart} exact path="/cart" />
                    <Route component={Order} exact path="/Order"/>
                </Switch>
                <Footer />
            </BrowserRouter>
        </Theme>
    );
}

export default App;
